export const SHOW_DESCRIPTION = true;
export const SHOW_TARGETED_ANNUAL_CASH_YIELD = true;
export const SHOW_TARGETED_TOTAL_RETURN = true;
export const SHOW_INVESTMENT_PERIOD = true;
export const SHOW_PRICING_TEXT = true;
export const SHOW_MINIMUM_INVESTMENT = true;
export const SHOW_INVESTMENT_TYPE = true;
export const SHOW_LOCATION_TEXT = true;
export const CARDS_REFERENCE = [
  {
    id: "sjbjs778sjhbhv",
    imageSrc:
      "https://firebasestorage.googleapis.com/v0/b/mulkinvest-613c0.appspot.com/o/AlaToo.png?alt=media&token=1d24421a-8edb-44f1-9c30-11b570a36d8a",
    title: "Ala Too Towers",
    description:
      "Ala Too Towers is a mixed-use luxury real estate development project in Bishkek, the capital city of Kyrgyzstan.",
    locationText: "Kyrgyzstan",
    pricingText: "USD 158 million",
    status: true,
    investmentPeriod: "3 Years",
    investmentType: "Real estate development project",
    subtitle: "Active",
    targetedTotalReturn: "132.00",
    targetedAnnualCashYield: "12.00%",
    minimumInvestment: "USD 500",
  },
  {
    id: "sjvnkl33048dsf",
    imageSrc:
      "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&h=1024&w=768&q=80",
    title: "Soho Towers",
    description:
      "Lorem ipsum dolor sit amet, consectur dolori adipiscing elit, sed do eiusmod tempor nova incididunt ut labore et dolore magna aliqua.",
    locationText: "Ibiza, Spain",
    pricingText: "Coming Soon",
    subtitle: "Coming Soon",
    status: false,
    minimumInvestment: "Not Disclosed",
    targetedTotalReturn: "Not Disclosed",
    investmentPeriod: "Not Disclosed",
    investmentType: "Real estate development project",
    targetedAnnualCashYield: "N/A",
  },
  {
    id: "ssdcsc98978sdc",
    imageSrc:
      "https://images.unsplash.com/photo-1549294413-26f195200c16?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&h=1024&w=768&q=80",
    title: "Wyatt Residency",
    description:
      "Lorem ipsum dolor sit amet, consectur dolori adipiscing elit, sed do eiusmod tempor nova incididunt ut labore et dolore magna aliqua.",
    locationText: "Palo Alto, CA",
    pricingText: "Coming Soon",
    subtitle: "Coming Soon",
    status: false,
    targetedTotalReturn: "Not Disclosed",
    investmentPeriod: "Not Disclosed",
    investmentType: "Real estate development project",
    targetedAnnualCashYield: "N/A",
    minimumInvestment: "Not Disclosed",
  },
];
